module.exports = __webpack_public_path__ + "static/apple-4x-v2-8c8c9d0e5408beed03befe54a3c793bf.png";